import { Component, Input, inject } from '@angular/core'
import { Idle } from '@ng-idle/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { ToastrService } from 'ngx-toastr'
import { BehaviorSubject } from 'rxjs'
import { HospitalPricingService } from '../../hospital-pricing.service'

@Component({
   selector: 'vc-coversheet-modal',
   templateUrl: './coversheet-modal.component.html',
   styleUrl: './coversheet-modal.component.scss',
   standalone: false,
})
export class VetcorCoverSheetModalComponent {
   sourceInputValue: string = ''
   displayModal = true

   @Input() pricingCaptain = this.hospitalPricingService.pricingCaptain
   @Input() activeCycle = this.hospitalPricingService.activeCycle
   @Input() practiceSKey = 0

   constructor(
      private toastr: ToastrService,
      private bsModalRef: BsModalRef,
      private idle: Idle,
      public hospitalPricingService: HospitalPricingService
   ) {
      this.idle.onTimeout.subscribe(() => {
         this.onClose()
      })
   }

   getDaySuffix(dateString: Date): string {
      const date = new Date(dateString)
      const day = date.getDate()

      if (day >= 11 && day <= 13) return 'th'
      switch (day % 10) {
         case 1:
            return 'st'
         case 2:
            return 'nd'
         case 3:
            return 'rd'
         default:
            return 'th'
      }
   }

   onClose(): void {
      this.bsModalRef.hide()
   }
}
